import { z } from 'zod';

/**
 * The open operation lives in the URL, so "the endpoint I am looking at" is a
 * link. Its id is `method:path` — free-form rather than an enum, because the
 * document it comes from is the running API's and this build cannot know what
 * is in it.
 */
export const apiConsoleSearchSchema = z.object({
  op: z.string().trim().min(1).max(240).optional().catch(undefined),
  /**
   * One filter over path, summary and tag, rather than a row of tag tabs.
   *
   * The document has a hundred-odd operations across a dozen tags, so the tabs
   * were a second thing to scan before the list; typing "foods" narrows to the
   * same set and typing "/foods/:id" narrows further, which the tabs could not.
   */
  q: z.string().trim().min(1).max(120).optional().catch(undefined),
});

export type ApiConsoleSearch = z.infer<typeof apiConsoleSearchSchema>;
